import FormValidation from "../../Validation/FormValidation";

const Hidden = {

    bind(form) {
        this.input = 'input[type="hidden"]';
    },

    check(form) {
        let ok = true;
        form.find(this.input).each((i, el) => {
            ok &= this.isValid($(el));
            FormValidation.setValid($(el),  this.isValid($(el)), true);
        })
        return ok;
    },

    isValid(input) {
        const isRequired = input.is('.required') || input.closest('.input').is('.required');

        if (isRequired) return !!input.val()
        else return true;
    },
}

export default Hidden;
